/**
 * ANONYMOUS_STUDIO_PATHS are the public studio surfaces whose identity comes from a
 * scoped credential — the embed's publishable key, the share link's share token — rather
 * than an Ory session. They are un-nested from the _app layout (the trailing underscore
 * on their `studio_` route segment), so they inherit neither the auth guard nor the app
 * shell, and nothing about them should reach for the visitor's own session.
 */
const ANONYMOUS_STUDIO_PATHS = ["/studio/embed", "/studio/share"] as const;

/**
 * isAnonymousStudioPath reports whether a pathname is one of the public studio surfaces.
 * The match is segment-aware — an exact hit or a `/`-delimited descendant — so a route
 * that merely shares a prefix (/studio/embedded, /studio/shared) is correctly excluded.
 *
 * This is the single source of truth for that question: both the root guard (which skips
 * the Ory whoami for these paths) and the entry's idle studio-chunk warming (which must
 * not preload a route whose guard would fire that same whoami) read it here, so the two
 * can never drift when a new public surface is added.
 */
export const isAnonymousStudioPath = (pathname: string): boolean =>
  ANONYMOUS_STUDIO_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
